class SiteActionPost
    extends SiteAction {

    private readonly _action: IActionTypePost;
    private readonly _card: ISiteCard;

    constructor(card: ISiteCard, action: IActionTypePost, next: SiteAction | null) {
        super(next);
        this._action = action;
        this._card = card;
    }
    async _execute() {
        return await this._card.post(this._action);
    }
}